var _path, _path2, _path3, _path4;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgGcp(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    className: "svg-icon",
    style: {
      width: "1em",
      height: "1em",
      verticalAlign: "middle",
      fill: "currentColor",
      overflow: "hidden"
    },
    viewBox: "0 0 1024 1024",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M629.251413 354.358613h26.576214l75.74528-75.74528 3.720533-32.157013a340.456107 340.456107 0 0 0-553.867947 166.106453 41.19552 41.19552 0 0 1 26.576214-1.594026l151.49056-24.9856s7.707307-12.755627 11.69408-11.956907a188.962133 188.962133 0 0 1 258.594133-19.667627z",
    fill: "#F44336"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M839.4752 412.562773a341.251413 341.251413 0 0 0-102.85056-165.843626l-106.31168 106.31168a188.962133 188.962133 0 0 1 69.369173 149.89312v18.87232a94.6176 94.6176 0 1 1 0 189.228373h-189.231786l-18.868907 19.135147v113.486506l18.868907 18.868907h189.231786a246.104747 246.104747 0 0 0 139.79648-449.952427z",
    fill: "#448AFF"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M320.948907 861.453653h189.228373v-151.49056H320.948907a94.08512 94.08512 0 0 1-39.069014-8.506026l-26.579626 8.239786-76.274347 75.741867-6.64576 26.579627a244.77696 244.77696 0 0 0 148.568747 49.435306z",
    fill: "#43A047"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M320.948907 370.039467a246.104747 246.104747 0 0 0-148.568747 441.18016l109.765973-109.76256a94.6176 94.6176 0 1 1 125.177174-125.177174l109.76256-109.765973a245.838507 245.838507 0 0 0-196.13696-96.474453z",
    fill: "#FFC107"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgGcp);
export default __webpack_public_path__ + "static/media/gcp.3aa3550ddcd292dec21968ca4dffc6a0.svg";
export { ForwardRef as ReactComponent };